import { useAtom } from "jotai";
import {
  employeeInfoAtom,
  EmployeeInfoType,
  recordingSettingAtom,
} from "../store";
import { useCallback, useRef } from "react";
import { voislogApi } from "./apiClients/voislogApi";
import { ApiError } from "./apiClients/ApiError";
import { AccessToken } from "../types";

type SettingInfo = (token: AccessToken) => Promise<void>;

export function useSetSetting(): SettingInfo {
  const lastUserId = useRef<string | null>(null);
  const [, setEmployeeInfo] = useAtom(employeeInfoAtom);
  const [, setRecordingSetting] = useAtom(recordingSettingAtom);

  return useCallback(
    async (token) => {
      // 同じユーザーの場合は何もしない
      if (lastUserId.current === token.user_id) {
        return;
      }

      try {
        const {
          data: me,
          error: meError,
          response: meResponse,
        } = await voislogApi.GET("/v2/core/users/{user_id_or_me}", {
          params: { path: { user_id_or_me: token.user_id } },
        });
        if (meError) throw new ApiError(meResponse, "get", meError);
        const employeeInfo: EmployeeInfoType = {
          employee_id: me.email,
          company_id: me.companies?.find((c) => c.is_member)?.id ?? "",
          employee_name: `${me.last_name} ${me.first_name}`,
        };
        setEmployeeInfo(employeeInfo);
        lastUserId.current = token.user_id;
      } catch {
        console.log("not get settings.");
      }

      try {
        const { data, error, response } = await voislogApi.GET(
          "/v2/v_management/app_settings/recording",
        );
        if (error) throw new ApiError(response, "get", error);
        setRecordingSetting(data);
      } catch {
        console.log("not get recording settings.");
      }
    },
    [setEmployeeInfo, setRecordingSetting],
  );
}
